import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '@assets/img/icons/arrow-down.svg?react';
import { H3, StringXSmall } from '@components/Typography/Typography';
import { Picture } from '@components/ui/Picture/Picture';

import boostPng from '/img/icons/boost.png';
import boostWebp from '/img/icons/boost.webp';
import productionPng from '/img/icons/production_pool.png';
import productionWebp from '/img/icons/production_pool.webp';

interface CompateItemProps {
  kind: string;
  now: string | number;
  next: string | number;
  withoutNext?: boolean;
}

const CompateItem: FC<CompateItemProps> = ({
  kind,
  now,
  next,
  withoutNext,
}) => {
  const { t } = useTranslation();
  const description =
    kind === 'production' ? 'Processing speed per hour' : 'Cycle Load';

  const images: Record<string, { png: string; webp: string }> = {
    production: {
      png: boostPng,
      webp: boostWebp,
    },
    load: {
      png: productionPng,
      webp: productionWebp,
    },
  };

  return (
    <div className="flex flex-col items-center">
      <Picture
        className="w-[4.5rem] h-[4.5rem] shrink-0"
        img={images[kind].png}
        webp={images[kind].webp}
        alt={kind}
      />
      <StringXSmall weight="regular" className="text-white/40 mb-1">
        {t(description)}
      </StringXSmall>
      <div className="flex items-center gap-2">
        <H3
          weight="bold"
          className={withoutNext ? '!text-accent' : '!text-white'}
        >
          {now}
        </H3>
        {!withoutNext && (
          <>
            <ArrowDownIcon className="w-4 h-4 shrink-0 -rotate-90 text-white/30" />
            <H3 weight="bold" className="!text-accent">
              {next}
            </H3>
          </>
        )}
      </div>
    </div>
  );
};

export { CompateItem };
